<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>合伙人列表</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="btn_box">
        <div class="item">
          <!-- <el-button class="newAdd">新增顶级合伙人</el-button> -->
          <AddUP
            v-if="$hasPerm('tenant:partner_list:add_top_partner')"
            @refresh="refreshList"
          ></AddUP>
        </div>
        <div class="item">
          <!-- <el-button class="newAdd">添加合伙人</el-button> -->
          <Add
            v-if="$hasPerm('tenant:partner_list:add_partner')"
            @refresh="refreshList"
          ></Add>
        </div>
        <div class="item">
          <!-- <el-button class="channelUserIdnewAdd" >合伙人迁移</el-button> -->
          <Move
            v-if="$hasPerm('tenant:partner_list:move_partner')"
            @refresh="refreshList"
          ></Move>
        </div>
        <div class="item">
          <Modify
            v-if="$hasPerm('tenant:partner_list:modify_partner')"
            @refresh="refreshList"
          ></Modify>
        </div>
        <div class="item">
          <UpdateAffaires
            v-if="$hasPerm('tenant:partner_list:update_affaires')"
            @refresh="refreshList"
          ></UpdateAffaires>
        </div>
        <div class="item">
          <BelongRecord v-if="$hasPerm('tenant:partner_list:belong_record')" />
        </div>
        <div class="item">
          <Mark
            v-if="$hasPerm('tenant:partner_list:mark_abnormal_agent')"
            @refresh="refreshList"
          ></Mark>
        </div>
        <div class="item">
          <ModifyRate
            v-if="$hasPerm('tenant:partner_list:modify_rebate_rate')"
            @refresh="refreshList"
          ></ModifyRate>
        </div>
        <div class="item">
          <AddAffaires
            v-if="$hasPerm('tenant:partner_list:add_affaires')"
            @refresh="refreshList"
          ></AddAffaires>
        </div>

        <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId">
              </el-input>
            </div>
          </div> -->

        <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
      </div>
      <div class="ipt_box select">
        <div class="item">
          <div class="ipt">
            <!-- <div class="pre">UID:</div> -->
            <el-input
              placeholder="合伙人UID"
              size="mini"
              clearable
              v-model="channelUserId"
            >
            </el-input>
          </div>
        </div>
        <div class="item">
          <div class="ipt">
            <!-- <div class="pre">备注:</div> -->
            <el-input placeholder="备注" size="mini" clearable v-model="remark">
            </el-input>
          </div>
        </div>
        <div class="item">
          <div class="ipt">
            <!-- <div class="pre tel">手机号:</div> -->
            <el-input
              placeholder="请输入手机号"
              size="mini"
              clearable
              v-model="phone"
            >
            </el-input>
          </div>
        </div>
        <div class="item">
          <div class="ipt">
            <!-- <div class="pre">邮箱:</div> -->
            <el-input
              placeholder="请输入邮箱"
              size="mini"
              clearable
              v-model="email"
            >
            </el-input>
          </div>
        </div>
        <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId">
              </el-input>
            </div>
          </div> -->

        <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
        <div class="item">
          <el-button size="mini" type="primary" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </div>

      <user-list @refresh="refreshList"></user-list>
      <!-- <BelongRecord /> -->
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Move from './components/move'
import Add from './components/add'
import AddUP from './components/addUP'
import Modify from './components/modify'
import Mark from './components/mark'
import BelongRecord from './components/belongRecord'
import UpdateAffaires from './components/updateAffaires'
import AddAffaires from './components/AddAffaires'
import ModifyRate from './components/modifyRate'
import { mapState, mapActions, mapMutations } from 'vuex'
import { QUERY_TYPE, PAGINATION } from './constants'
import moment from 'moment'
export default {
  name: 'partnerList',
  components: {
    UserList,
    Move,
    Add,
    AddUP,
    Modify,
    BelongRecord,
    Mark,
    ModifyRate,
    UpdateAffaires,
    AddAffaires,
  },
  data() {
    return {
      remark: '',
      value2: '',
      dialogVisible: false,
      phone: '',
      email: '',
      channelUserId: '',
      inviteBy: '',
      value1: [
        moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('partnerList', ['queryType', 'pagination', 'orderBy']),
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions('partnerList', ['list', 'addUser']),
    ...mapMutations('partnerList', ['setQueryType']),
    refreshList(data = {}) {
      this.list({
        phone: this.phone,
        email: this.email,
        channelUserId: this.channelUserId,
        remark: this.remark,
        orderBy: this.orderBy,
        ...this.pagination,
        ...data,
      })
    },
    changeTime(e) {
      this.list({
        phone: this.phone,
        remark: this.remark,
        email: this.email,
        orderBy: this.orderBy,
        channelUserId: this.channelUserId,
        ...PAGINATION,
      })
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
      ]
      this.handleSearch()
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ]
      this.handleSearch()
    },
    handleSearch() {
      this.list({
        phone: this.phone,
        email: this.email,
        orderBy: this.orderBy,
        remark: this.remark,
        channelUserId: this.channelUserId,
        ...PAGINATION,
      })
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
  },
  mounted() {
    this.list({
      remark: this.remark,
      phone: this.phone,
      orderBy: this.orderBy,
      email: this.email,
      channelUserId: this.channelUserId,
      ...PAGINATION,
    })
  },
}
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.btn_box {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.ipt_box {
  // gap: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
